import React from 'react';
import 'twin.macro';
import { useLocation, useNavigate } from 'react-router-dom';
import useEDTPrint from 'queries/edt/useEDTPrint';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';
import { EDTTable } from 'containers/EmploiDuTemps/Print/EDTTable';
import H2 from 'components/Typography/Headings/H2';
import Button from 'components/Buttons/Button';
import { SubmitButton } from 'containers/EmploiDuTemps/New/PreviewOld/SubmitButton';
import { useTranslation } from 'react-i18next';

export function PreviewOld() {
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const edtId = urlSearchParams.get('edt-id') || undefined;
  const schoolyearId = urlSearchParams.get('schoolyear-id') || undefined;
  const { t } = useTranslation(['emploiDuTemps', 'common']);
  const navigate = useNavigate();
  const schoolId = urlSearchParams.get('school-id') || undefined;

  const { data, isLoading } = useEDTPrint({
    edtId: edtId!,
    schoolId: schoolId!,
    schoolyearId: schoolyearId!,
  });
  if (!schoolyearId || !schoolId || !edtId) {
    navigate(-1);
    return null;
  }

  if (!data || isLoading) {
    return <SpinnerComponent />;
  }

  const { edt, classrooms } = data;
  return (
    <div tw="pt-8 flex flex-col h-full relative min-h-0">
      <div tw="text-center mb-8">
        <H2>{t('emploiDuTemps:new.previewEdt', { edtName: edt.name })}</H2>
      </div>
      <div tw="px-8 flex-1 min-h-0 overflow-auto pt-1 pb-8">
        <div tw="bg-white">
          <EDTTable
            key={edt.id}
            settings={{
              disableClassroomBar: false,
              disableRelativeSlices: false,
              disableVolumeHoraire: false,
              displaylength: false,
              fontSize: 12,
              font: 'Inter',
              eventColor: 'auto',
              smallBreak: true,
              selectedClassrooms: classrooms.map(cl => cl.id),
            }}
            classrooms={classrooms}
            emploiDuTemps={edt}
            maxHeight={
              // ça sort du chapeau, c'est simplement pour que ça tiennent sur un écran 1200px de haut
              824
            }
          />
        </div>
      </div>
      <div tw="flex-shrink-0 bg-white p-4 rounded-t-2xl bg-opacity-80 border-t shadow-xl">
        <div tw="flex justify-center items-center gap-x-4">
          <Button onClick={() => navigate(-1)} extralarge>
            {t('common:buttons.cancel')}
          </Button>
          <SubmitButton
            edtId={edtId}
            srcClassrooms={classrooms}
            srcSchoolyearId={schoolyearId}
            srcSchoolId={schoolId}
          />
        </div>
      </div>
    </div>
  );
}
